import './LoadingButton.css';
export default {
    "root": "LoadingButton_root__1q07g",
    "animation": "LoadingButton_animation__1q07g",
    "rotating": "LoadingButton_rotating__1q07g",
    "hidden": "LoadingButton_hidden__1q07g",
    "animationSmall": "LoadingButton_animationSmall__1q07g",
    "animationMedium": "LoadingButton_animationMedium__1q07g",
    "animationDefault": "LoadingButton_animationDefault__1q07g",
    "animationLarge": "LoadingButton_animationLarge__1q07g",
    "loadingSmall": "LoadingButton_loadingSmall__1q07g",
    "loadingMedium": "LoadingButton_loadingMedium__1q07g",
    "loadingLarge": "LoadingButton_loadingLarge__1q07g"
};
